<template>
    <div class="component-buscador">
        <label for="component-buscador" class="labelInput">
            Alumno
        </label>
        <input type="text" 
            class="form-control mr-0"
            placeholder="Seleccione un alumno"
            v-model="text"
            id="component-buscador">
            <div class="list buscadorFactura" :hidden="hidden">
                <p class="message m-0">{{message}}</p>
                <div v-for="item in data" :key="item.id+'-'+item.subject+'-'+item.institucion_id" @click="navigate(item)">
                    <div class="objeto">
                        <div class="d-flex justify-content-between ">
                            <span class="title">{{item.title}}</span>
                            <span :class="'ml-1 subject ' + (item.subject == 'Módulo' ? 'red' : (item.subject == 'Prospecto' ? 'green' : 'blue'))">
                                {{item.subject}}
                            </span>
                        </div>
                        <div class="d-block">
                            <span v-if="item.matricula">Matrícula <span class="matricula">{{item.matricula}}</span></span>
                            <span v-if="item.matricula_sim">SIM <span class="matricula sim">{{item.matricula_sim}}</span></span>
                        </div>
                        <div class="d-block">
                            <i class="fas fa-graduation-cap mr-1"></i>
                            <span>{{item.subtitle}}</span>
                        </div>
                        <div v-if="multiple == true && item.subject != 'Módulo'" class="d-block">
                            <i class="fas fa-school mr-1"></i>
                            <span>{{item.institucion}}</span>
                        </div>
                    </div>
                </div>
            </div>
        <button v-show="text != ''"
            class="btn btn-sm clear" 
            id="component-buscador-clear"
            type="button">
            <i class="fas fa-times"></i>
        </button>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    data() {return {
        hidden: true,
        text: '',
        data: [],
        message: 'Al menos 4 letras...',
        multiple: false,
    }},
    mounted() {
        const vm = this;
        const searchbar = $('#component-buscador');
        const clearBtn = $('#component-buscador-clear');

        searchbar.focus(function() {
            vm.hidden = false;
        });
        searchbar.focusout(function() {
            setTimeout(function() {
                if(!searchbar.is(':focus')) {
                    vm.hidden = true;
                }
            }, 200);   
        });

        let timeout = null;
        searchbar.on('input', function() {
            if(vm.text.length < 4) {
                vm.message = 'Al menos 4 letras...'
                vm.data = [];
            } else {
                vm.message = 'Buscando...';
            }

            if (timeout !== null) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function() {
                if(vm.text != '' && vm.text.length > 3) {
                    vm.get();
                }
            }, 1000); 
        });

        clearBtn.on('click', function() {
            vm.text = '';
            vm.data = [];
            vm.message = 'Al menos 4 letras...'
            searchbar.focus();
        });
    },
    methods: {
        get() {
            Axios.get('/buscador', {params: {text: this.text}}).then(res => {
                this.data = res.data.data;
                console.log(this.data)
                this.multiple = res.data.multiple;
                this.message = 'Se encontraron ' + res.data.data.length + ' resultados';
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error en el componente v-header-searchbar');
                }
            });
        },
        navigate(item) {
            console.log(item)
            this.text = item.title + ' - ' + item.matricula
            this.$emit('infoAlumno',item)
            // location.assign(item.url 
            //     + (item.subject != 'Módulo' ? window.btoa(item.id) : '')
            //     + '/institucion/'
            //     + window.btoa(item.institucion_id)
            // );
        }
    },
}
</script>
